/* @flow */
import { membershipDescriptionFor } from 'groups/lib/groupDisplay';
import Button from 'components/Button.jsx';
import ButtonGroup from 'components/ButtonGroup.jsx';
import { Container } from 'flux/utils';
import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import GroupInviteModal from 'groups/components/GroupInviteModal.jsx';
import GroupName from 'groups/components/GroupName.jsx';
import Hovercard from 'components/Hovercard.jsx';
import HovercardBody from 'components/HovercardBody.jsx';
import HovercardFooter from 'components/HovercardFooter.jsx';
import Link from 'components/Link.jsx';
import Messages from 'collections/Messages';
import MessageActions from 'groups/actions/MessageActions';
import MessageStore from 'groups/stores/MessageStore';
import ModalTrigger from 'components/ModalTrigger.jsx';
import PDFDownload from 'components/PDFDownload.jsx';
import React from 'react';
import Text from 'components/Text.jsx';

import './styles/GroupHovercard.scss';

type Props = {
  group: Group,
}

type State = {
  messagesScheduled: Messages,
}

class GroupHovercard extends React.Component {
  props: Props;
  state: State;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  static getStores() {
    return [
      MessageStore,
    ];
  }

  static calculateState = (prevState: ?State, props: Props): State => {
    const { group } = props;
    return {
      messagesScheduled: MessageStore.getMessagesScheduled(group.id),
    };
  }

  componentDidMount() {
    const { group } = this.props;

    if (group.isOwnedByUser(CurrentUser.getUserId())) {
      const messagesScheduled = MessageStore.getMessagesScheduled(group.id);
      if (messagesScheduled.isEmpty()) {
        MessageActions.loadScheduledMessages(group.id);
      }
    }
  }

  getGroupLink = (group: Group) => {
    return `/classes/${group.getCode()}`;
  };

  goToPeopleTab = () => {
    const { group } = this.props;
    this.context.router.push(`/classes/${group.getCode()}/people/`);
  };

  renderInviteButton = () => {
    const { group } = this.props;
    if (!group.canAddPeople()) {
      return null;
    }

    const addPeopleButton = (
      <ModalTrigger modal={<GroupInviteModal group={group} />}>
        <Button
          className="GroupHovercard-addButton"
          eventElementName="GroupHovercard-addButton">
          Add people
        </Button>
      </ModalTrigger>
    );

    return (
      <ButtonGroup
        className="GroupHovercard-inviteButton"
        level="primary"
        color="brand"
        size="small">
        {addPeopleButton}
        <PDFDownload
          type="button"
          group={group}
          tooltip="Download PDF instructions"
          tooltipPlacement="bottom"
          tooltipAlignment="right">
          <Glyph name="download" solo />
        </PDFDownload>
      </ButtonGroup>
    );
  };

  renderScheduledAnnouncements = () => {
    const { group } = this.props;

    const count = this.state.messagesScheduled.length;
    if (count === 0) {
      return null;
    }

    return (
      <HovercardFooter>
        <Link
          to={this.getGroupLink(group)}
          query={{ openScheduledMessages: true }}>
          <Glyph name="schedule" />
          <Text weight="semibold">
            {count === 1 ? `${count} scheduled announcement` : `${count} scheduled announcements`}
          </Text>
        </Link>
      </HovercardFooter>
    );
  };

  renderSubscriberCount = () => {
    const { group } = this.props;
    const count = group.getMembershipsCount();
    const subscribersCount = membershipDescriptionFor(group);

    if (count > 0) {
      return (
        <Link
          to={`/classes/${group.getCode()}/people`}
          color="thunder">
          {subscribersCount}
        </Link>
      );
    }
    return subscribersCount;
  };

  renderSubtext = () => {
    const { group } = this.props;
    const groupCodeOpt = `@${group.getCode()} \u2022 `;
    return (
      <Text className="GroupHovercard-subtext" color="thunder">
        {groupCodeOpt}
        {group.isOwnedByUser(CurrentUser.getUserId()) && this.renderSubscriberCount()}
      </Text>
    );
  };

  render() {
    const { group } = this.props;

    return (
      <Hovercard
        {...this.props}
        className="GroupHovercard">
        <HovercardBody>
          <Link to={this.getGroupLink(group)} color="pitch">
            <GroupAvatar className="GroupHovercard-avatar" group={group} />
            <h6 className="GroupHovercard-name">
              <Text truncate>
                <GroupName group={group} />
              </Text>
            </h6>
          </Link>
          {group.isRoot() || this.renderSubtext()}
          {this.renderInviteButton()}
        </HovercardBody>
        {this.renderScheduledAnnouncements()}
      </Hovercard>
    );
  }
}

export default Container.create(GroupHovercard, { withProps: true });



// WEBPACK FOOTER //
// ./src/groups/components/GroupHovercard.jsx